import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["totalPrice", "originalPrice", "discountMessage", "submitButton", "paymentSection", "overlay", "overlayMessage"]
  static outlets = ["photo-upload", "discount-code"]

  connect() {
    this.activeDiscount = null
    this.requiredPhotoCount = 6
    this.checkFormValidity()
  }

  updatePrice(event) {
    const selectedInput = event.target
    if (selectedInput.checked) {
      if (this.hasPhotoUploadOutlet) {
        this.photoUploadOutlet.updateRequiredCount(this.requiredPhotoCount)
      }

      // Re-validate discount against new size if one is applied
      if (this.activeDiscount && this.hasDiscountCodeOutlet) {
        this.discountCodeOutlet.apply()
      } else {
        this._refreshPriceDisplay()
      }

      this.checkFormValidity()
    }
  }

  applyDiscount(data) {
    this.activeDiscount = data
    this.requiredPhotoCount = 12
    if (this.hasPhotoUploadOutlet) {
      this.photoUploadOutlet.updateRequiredCount(12)
    }
    this._refreshPriceDisplay()
    this.checkFormValidity()
  }

  clearDiscount() {
    this.activeDiscount = null
    this.requiredPhotoCount = 6
    if (this.hasPhotoUploadOutlet) {
      this.photoUploadOutlet.updateRequiredCount(6)
    }
    this._refreshPriceDisplay()
    this.checkFormValidity()
  }

  checkFormValidity() {
    const selectedSize = document.querySelector('input[name="order[magnet_size]"]:checked')
    const photoUploadController = this.hasPhotoUploadOutlet ? this.photoUploadOutlet : null

    let isValid = false
    if (selectedSize && photoUploadController) {
      const selectedCount = photoUploadController.getFileCount()
      isValid = selectedCount > 0 && selectedCount === this.requiredPhotoCount
    }

    if (isValid) {
      this.paymentSectionTarget.classList.remove('hidden')
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.classList.remove('opacity-50', 'cursor-not-allowed')

      if (typeof initializePayPalButtons === 'function') {
        initializePayPalButtons()
      }
    } else {
      this.paymentSectionTarget.classList.add('hidden')
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add('opacity-50', 'cursor-not-allowed')
    }
  }

  showSubmitProgress(event, message = 'Submitting your order...') {
    if (this.hasOverlayTarget) {
      if (this.hasOverlayMessageTarget) {
        this.overlayMessageTarget.textContent = message
      }
      this.overlayTarget.classList.remove('hidden')
    }
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.value = 'Submitting...'
    }
  }

  _refreshPriceDisplay() {
    const selectedInput = document.querySelector('input[name="order[magnet_size]"]:checked')
    if (!selectedInput) {
      this.totalPriceTarget.textContent = 'Select size'
      this.originalPriceTarget.classList.add('hidden')
      this.discountMessageTarget.classList.add('hidden')
      return
    }

    const basePrice = parseFloat(selectedInput.dataset.price)

    if (this.activeDiscount && this.activeDiscount.total_price !== undefined) {
      const fullTwoSetPrice = (basePrice * 2).toFixed(2)
      const discountedTotal = this.activeDiscount.total_price.toFixed(2)
      const secondSetPrice = this.activeDiscount.second_set_price.toFixed(2)
      const pct = Math.round(this.activeDiscount.discount_percentage)

      this.originalPriceTarget.textContent = '$' + fullTwoSetPrice
      this.originalPriceTarget.classList.remove('hidden')
      this.totalPriceTarget.textContent = '$' + discountedTotal
      this.discountMessageTarget.textContent =
        `1st set $${basePrice.toFixed(2)} + 2nd set $${secondSetPrice} (${pct}% off) — upload 12 photos total`
      this.discountMessageTarget.classList.remove('hidden')
    } else {
      this.originalPriceTarget.classList.add('hidden')
      this.totalPriceTarget.textContent = '$' + basePrice.toFixed(2)
      this.discountMessageTarget.classList.add('hidden')
    }
  }
}
